export const frenchDepartments: Record<string, string> = {
  'Haute-Corse': 'de la ',
  'Corse-du-Sud': 'de la ',
  'Ain': 'de l\'',
  'Aisne': 'de l\'',
  'Allier': 'de l\'',
  'Alpes-de-Haute-Provence': 'des ',
  'Hautes-Alpes': 'des ',
  'Alpes-Maritimes': 'des ',
  'Ardèche': 'de l\'',
  'Ardennes': 'des ',
  'Ariège': 'de l\'',
  'Aube': 'de l\'',
  'Aude': 'de l\'',
  'Aveyron': 'de l\'',
  'Bouches-du-Rhône': 'des ',
  'Calvados': 'du ',
  'Cantal': 'du ',
  'Charente': 'de la ',
  'Charente-Maritime': 'de la ',
  'Cher': 'du ',
  'Corrèze': 'de la ',
  "Côte-d'Or": 'de la ',
  "Côtes-d'Armor": 'des ',
  'Creuse': 'de la ',
  'Dordogne': 'de la ',
  'Doubs': 'du ',
  'Drôme': 'de la ',
  'Eure': 'de l\'',
  'Eure-et-Loir': 'de l\'',
  'Finistère': 'du ',
  'Gard': 'du ',
  'Haute-Garonne': 'de la ',
  'Gers': 'du ',
  'Gironde': 'de la ',
  'Hérault': 'de l\'',
  'Ille-et-Vilaine': 'de l\'',
  'Indre': 'de l\'',
  'Indre-et-Loire': 'de l\'',
  'Isère': 'de l\'',
  'Jura': 'du ',
  'Landes': 'des ',
  'Loir-et-Cher': 'du ',
  'Loire': 'de la ',
  'Haute-Loire': 'de la ',
  'Loire-Atlantique': 'de la ',
  'Loiret': 'du ',
  'Lot': 'du ',
  'Lot-et-Garonne': 'du ',
  'Lozère': 'de la ',
  'Maine-et-Loire': 'du ',
  'Manche': 'de la ',
  'Marne': 'de la ',
  'Haute-Marne': 'de la ',
  'Mayenne': 'de la ',
  'Meurthe-et-Moselle': 'de la ',
  'Meuse': 'de la ',
  'Morbihan': 'du ',
  'Moselle': 'de la ',
  'Nièvre': 'de la ',
  'Nord': 'du ',
  'Oise': 'de l\'',
  'Orne': 'de l\'',
  'Pas-de-Calais': 'du ',
  'Puy-de-Dôme': 'du ',
  'Pyrénées-Atlantiques': 'des ',
  'Hautes-Pyrénées': 'des ',
  'Pyrénées-Orientales': 'des ',
  'Bas-Rhin': 'du ',
  'Haut-Rhin': 'du ',
  'Rhône': 'du ',
  'Haute-Saône': 'de la ',
  'Saône-et-Loire': 'de la ',
  'Sarthe': 'de la ',
  'Savoie': 'de la ',
  'Haute-Savoie': 'de la ',
  'Paris': 'de ',
  'Seine-Maritime': 'de la ',
  'Seine-et-Marne': 'de la ',
  'Yvelines': 'des ',
  'Deux-Sèvres': 'des ',
  'Somme': 'de la ',
  'Tarn': 'du ',
  'Tarn-et-Garonne': 'du ',
  'Var': 'du ',
  'Vaucluse': 'du ',
  'Vendée': 'de la ',
  'Vienne': 'de la ',
  'Haute-Vienne': 'des ',
  'Vosges': 'des ',
  'Yonne': 'de l\'',
  'Territoire de Belfort': 'du ',
  'Essonne': 'de l\'',
  'Hauts-de-Seine': 'des ',
  'Seine-Saint-Denis': 'de ',
  'Val-de-Marne': 'du ',
  "Val-d'Oise": 'du ',
  'Guadeloupe': 'de la ',
  'Martinique': 'de la ',
  'Guyane': 'de la ',
  'La Réunion': 'de ',
  'Mayotte': 'de ',
};

